/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import Button from '@material-ui/core/Button';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {|
  actionDrawerStore: TypeActionDrawerStore,
  response: Object,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class RemoveUsersSuccess extends React.Component<*> {
  render(): React.Node {
    const { t, actionDrawerStore, response }: TypeProps = this.props;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <div className={styles['success-details']}>
            <h3>{t('general:users.removed_from_location')}</h3>
            <p>{t('general:users.messages.removed_from_location')}</p>
            <p>
              {t(`${response.location.name} belonging to ${response.location.company_name}
                                company, and ${response.location.site_name} site.`)}
            </p>
            {response.users_removed &&
              response.users_removed.map((user: Object) => (
                <ul key={user.id}>
                  <li>
                    <b>{user.name}</b>
                  </li>
                  <li>{`${t('general:roles.labels.current_role')}: ${user.role}`}</li>
                </ul>
              ))}
          </div>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
